import React, { useEffect, useState } from 'react'
import { Button, IconButton } from '@material-ui/core'
import { FormControl, RadioGroup, Radio, FormControlLabel, Checkbox } from '@material-ui/core'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import { CloudUpload, Delete as DeleteIcon } from '@material-ui/icons'
import uploadIcon from '../../assets/images/uploadicon2.svg'
import { mapData } from '@/product/common/components'
import AuctionContext from '@/custom/context/auction/auctionContext'
import { dateFormatFront, currencyFormat } from '@/custom/common/components'
const PaymentMethodComponent = (props) => {
    const formikPayment = props.formik
    const [total, setTotal] = useState(0)

    useEffect(() => {
        if (formikPayment.values?.payment_lot_ids && props.list.length) {
            const selectedIdSet = new Set(formikPayment.values?.payment_lot_ids)

            const totalAmount = props.list.reduce((sum, item) => {
                if (selectedIdSet.has(item.id.toString())) {
                    return sum + Number(item.amount)
                }
                return sum
            }, 0)
            setTotal(totalAmount)
        }
    }, [formikPayment.values?.payment_lot_ids])
    const modeOfPayment = [
        {
            label: 'Select Mode of Payment',
            placeholder: 'Select Mode of Payment',
            type: 'select',
            class: 'col-12',
            upperLabel: true,
            options: [
                { value: 'cash', show: 'Cash' },
                { value: 'cheque', show: 'Cheque' },
                { value: 'dd', show: 'Demand Draft' },
                { value: 'rtgs', show: 'RTGS' },
                { value: 'neft', show: 'NEFT' },
            ],
            name: 'payment_method',
            formik: formikPayment,
        },

        {
            label: 'Bank Name',
            name: 'bank_name',
            upperLabel: true,
            type: '',
            placeholder: 'Enter Bank Name',
            class: `col-12 ${formikPayment.values.payment_method != 'cash' ? '' : 'd-none'}`,
            formik: formikPayment,
        },
        {
            label: 'Branch Name',
            name: 'branch',
            type: '',
            upperLabel: true,
            placeholder: 'Enter Branch Name',
            class: `col-12 ${formikPayment.values.payment_method != 'cash' ? '' : 'd-none'}`,
            formik: formikPayment,
        },
        {
            type: 'uploadDropZone',
            formik: formikPayment,
            name: 'proof_of_payment',
            icon: 'publish',
            class: 'col-12',
            titleText: 'Proof of Payment',
            innerText: 'Recommended dimensions: 1400px * 440px',

            folder: 'payment',
            multiple: false,
            accept: 'image/*,.pdf',
            formik: formikPayment,
        },
        {
            label: 'Payment Reference Number',
            name: 'actual_transaction_reference_number',
            upperLabel: true,
            type: '',
            placeholder: 'Enter Payment Reference Number',
            class: `col-12 ${formikPayment.values.payment_method != 'cash' ? '' : 'd-none'}`,
            formik: formikPayment,
        },
        {
            label: 'DD in favour of',
            upperLabel: true,
            name: 'dd_in_favour_of',
            type: '',
            placeholder: 'Enter DD in favour of',
            class: `col-12 ${formikPayment.values.payment_method == 'dd' ? '' : 'd-none'}`,
            formik: formikPayment,
        },
        // {
        //     label: 'Amount',
        //     name: 'amount',
        //     type: 'number',
        //     placeholder: 'Enter Amount',
        //     // class: `col-12 ${formikPayment.values.partial ? '' : 'd-none'}`,
        //     formik: formikPayment,
        // },
    ]

    return (
        <div>
            <div className="checkPayment">
                <div className="paySection">
                    <h3>Choose your payment mode</h3>
                    <div className="payment-options">
                        <FormControl component="fieldset">
                            <RadioGroup
                                row
                                aria-label="payment_type"
                                name="payment_type"
                                value={parseInt(formikPayment.values.payment_type, 10)}
                                onChange={formikPayment.handleChange}
                            >
                                <FormControlLabel
                                    value={1}
                                    control={<Radio color="primary" />}
                                    label="Offline"
                                />
                                {/* <FormControlLabel
                                    value={2}
                                    control={<Radio color="primary" />}
                                    label="Wallet"
                                /> */}
                                <FormControlLabel
                                    value={3}
                                    control={<Radio color="primary" />}
                                    label="Online"
                                />
                            </RadioGroup>
                        </FormControl>
                    </div>

                    {formikPayment.values['payment_type'] == 1 && (
                        <div className="accountCnt">
                            <div className="multiFormCnt">
                                {Object.values(mapData(modeOfPayment))}
                            </div>
                        </div>
                    )}

                    {formikPayment.values['payment_type'] == 2 && (
                        <div className="wallet-payment">
                            <div className="wallet-info d-flex justify-content-between align-items-center m-3">
                                <strong>Pay via wallet</strong>
                                <p className="mb-0">₹0</p>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="addMoneyButton"
                                    style={{
                                        height: '40px',
                                        color: 'white',
                                        background: '#094fa3',
                                        marginLeft: '20px',
                                    }}
                                >
                                    Add Money
                                </Button>
                            </div>
                        </div>
                    )}

                    {formikPayment.values['payment_type'] == 3 && (
                        <div className="online-payment">
                            <p>You will be redirected to our secure payment gateway</p>
                        </div>
                    )}
                </div>
            </div>
            <div className="paymentDetails checkPayment mt-3">
                <h3>Payment Details</h3>
                <table className="payment-details-table" style={{ width: '100%' }}>
                    <tbody>
                        <tr className="securityDeposit">
                            <td>Security Deposit for this Auction</td>
                            <td style={{ background: '#ffffff' }}>{currencyFormat(total)}</td>
                        </tr>
                        <tr className="totalAmount">
                            <td>Total amount to be paid</td>
                            <td>{currencyFormat(total)}</td>
                        </tr>

                        <tr>
                            <td colSpan="2">
                                <div className="getInTouchRow">
                                    <div className="getInTouchCol getInTouchColFull">
                                        <>
                                            <div className=" ">
                                                {Object.values(
                                                    mapData([
                                                        {
                                                            label: 'I agree to the terms & conditions',
                                                            name: 'termCheck',
                                                            type: 'checkbox',
                                                            class: `col-12`,
                                                            formik: formikPayment,
                                                        },
                                                    ]),
                                                )}
                                            </div>
                                        </>

                                        {/* <FormControlLabel
                                            control={<Checkbox color="primary" />}
                                            label="I agree to the terms & conditions"
                                            className="termsCheckbox"
                                        /> */}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2" style={{ padding: '0' }}>
                                <hr className="m-0" />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <div className="getInTouchCol searchEquip getInTouchColFull p-0">
                                    <Button
                                        variant="primary"
                                        fullWidth
                                        className="getInTouchSubmit submitButton"
                                        onClick={formikPayment.handleSubmit}
                                        style={{
                                            height: '40px',
                                            color: 'white',
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default PaymentMethodComponent
